import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Table } from 'libs.nucleus';
// Memoized Table Component to prevent unnecessary table rerenders
export const MemoizedTable = memo(({ data, columns, labelNoResults, paginationNavigationScreenReaderLabel, }) => {
    return (_jsx(Table, { data: data, columns: columns, labelNoResults: labelNoResults, hasPagination: true, initialPageSize: 50, paginationNavigationScreenReaderLabel: paginationNavigationScreenReaderLabel, enableSorting: true, getRowId: (row) => row.id }));
});
MemoizedTable.displayName = 'MemoizedTable';
